// Date input field - mode-aware
import { useFormContext } from 'react-hook-form';
import { Input, FieldError, FieldWrapper, FieldDisplay } from '@startus/ui';
import { useFormMode } from '../../hooks/useFormMode';
import type { BaseFieldProps } from '../../types/fields';

export function DateField({ name, label, placeholder, required }: BaseFieldProps) {
  const { isReadOnly } = useFormMode();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const value = watch(name);
  const error = errors[name]?.message as string | undefined;

  // Format date for display
  const displayValue = value ? new Date(value).toLocaleDateString() : '';

  if (isReadOnly) {
    return <FieldDisplay label={label} value={displayValue} required={required} />;
  }

  return (
    <FieldWrapper>
      {/*<Label required={required} fieldNumber={fieldNumber}>{label}</Label>*/}
      <Input {...register(name)} type="date" placeholder={placeholder} error={!!error} />
      <FieldError message={error} />
    </FieldWrapper>
  );
}
